import { FC, useState } from 'react'

import { SurveyResponseID } from '@forto-dev/notification-center-models'
import { Checkbox, Stack, Typography } from '@forto-dev/phoenix-ui-core'

import { SurveyQuestionProps, SurveyQuestionStatus } from '../domain/survey/surveyQuestionProps'
import { useRenderSurveyText } from '../hooks/survey/useRenderSurveyText'

export const CheckboxSurveyQuestion: FC<SurveyQuestionProps> = ({ question, onChange }) => {
  const { render } = useRenderSurveyText()
  const [answers, setAnswers] = useState<Set<SurveyResponseID>>(new Set())

  const handleOnChangeClick = (surveyResponseID: SurveyResponseID): void => {
    if (answers.has(surveyResponseID)) {
      answers.delete(surveyResponseID)
    } else {
      answers.add(surveyResponseID)
    }
    setAnswers(new Set(answers))
    onChange({
      surveyQuestionResponse: { id: question.id, responses: Array.from(answers).map((id) => ({ id })) },
      status: answers.size > 0 ? SurveyQuestionStatus.answered : SurveyQuestionStatus.unanswered,
    })
  }
  return (
    <Stack gap={16}>
      <Typography variant="body">{render(question)}</Typography>
      <Stack gap={8}>
        {question.responses.map((response) => (
          <Checkbox
            name="survey-questions"
            key={response.id}
            checked={answers.has(response.id as SurveyResponseID)}
            onCheckedChange={() => handleOnChangeClick(response.id as SurveyResponseID)}
            label={render(response)}
          />
        ))}
      </Stack>
    </Stack>
  )
}
